export default __webpack_public_path__ + "static/media/fire.978b93c6.svg";